import React from 'react';
import ReactDOM from 'react-dom';
import { pureRender } from 'epic-alt-utils';
import { NavActions } from '../../actions';
import autobind from 'core-decorators/lib/autobind';

@pureRender
export default class SearchExtension extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: ''
        };

        this.listenerOn = false;
    }

    addListener() {
        //Add a click listener anywhere on the page which will close the dropdown
        if (!this.listenerOn) {
            document.body.addEventListener('click', this.closeSearch);
            document.body.addEventListener('touchend', this.closeSearch);
            this.listenerOn = true;
        }
    }

    removeListener() {
        //remove the click listener
        if (this.listenerOn) {
            document.body.removeEventListener('click', this.closeSearch);
            document.body.removeEventListener('touchend', this.closeSearch);
            this.listenerOn = false;
        }
    }

    //move up parent nodes of target and see if any have id #search
    isValidClick(e) {
        let n = e ? e.target : null;
        if (!n) return false;

        let isValid = false;

        const checkId = () => {
            if (n.id === 'search') {
                isValid = true;
                return true;
            }

            //top of the tree and escape
            if (!n.parentNode || n.parentNode.tagName.toUpperCase() === 'BODY') {
                return false;
            }

            n = n.parentNode;
            checkId();
            return undefined;
        };

        checkId();

        return isValid;
    }

    @autobind
    closeSearch(e) {
        if (!this.isValidClick(e)) {
            if (e && e.target) {
                if (e.target.className !== 'search-input' || (e.target.firstChild && e.target.firstChild.className !== 'search-input')) {
                    NavActions.searchActive.defer(false);

                    //change focus to close keyboard on mobile
                    try {
                        ReactDOM.findDOMNode(this.refs.searchText).blur();
                    } catch (ex) {
                        if (process.env.NODE_ENV !== 'production') {
                            console.warn('failed to find searchText ref');
                        }
                    }
                }
            }
        }
    }

    clearSearchText() {
        if (this.state.searchText !== '') {
            this.setState({
                searchText: ''
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.active) {
            //this.clearSearchText();
        }

        if (!this.listenerOn && nextProps.active) {
            this.addListener();
        }

        if (this.listenerOn && !nextProps.active) {
            this.removeListener();
        }
    }

    componentWillUnmount() {
        this.removeListener();

        NavActions.searchActive(false);
    }

    componentDidUpdate() {
        this.setFocus();
    }

    componentDidMount() {
        this.setFocus();
    }

    setFocus() {
        if (this.props.active) {
            try {
                ReactDOM.findDOMNode(this.refs.searchText).focus();
            } catch (e) {
                if (process.env.NODE_ENV !== 'production') {
                    console.warn('failed to find searchText ref');
                }
            }
        }
    }

    @autobind
    onSearch(e) {
        if (this.props.onSearch && typeof this.props.onSearch === 'function') {
            setTimeout(() => {
                this.props.onSearch(this.state.searchText);
                if (this.context.isMobile) {
                    NavActions.closeMobileTablet();
                }
            }, 10);
        }
    }

    @autobind
    onFocus(e) {
        if (this.context.isMobile) {
            NavActions.searchActive(true);
        }
    }

    @autobind
    setSearch(e) {
        this.setState({
            searchText: e.currentTarget.value
        });
    }

    @autobind
    keyUp(e) {
        if (e && e.keyCode === 13) { //enter
            setTimeout(() => {
                this.onSearch();
            }, 10);
        }
    }

    render() {
        const active = this.props.active;

        let searchBoxActiveClass = 'search closed';
        if (active && this.context.isMobile) {
            searchBoxActiveClass = 'search active focus';
        } else if (active || this.context.isMobile) {
            searchBoxActiveClass = 'search active';
        }

        const messages = this.context.messages || {};
        const hidden = !this.state.searchText || this.state.searchText.length < 1 ? 'hidden' : '';

        let searchMaxWidth;
        if (this.context.isTablet && this.props.searchMaxWidth) {
            searchMaxWidth = this.props.searchMaxWidth;
        }

        return (
            <div
                id="form"
                className={searchBoxActiveClass}
                style={searchMaxWidth ? { maxWidth: searchMaxWidth } : null}>

                <div className="form-inline">
                    <div className="form-group">
                        <input
                            type="search"
                            name="q"
                            id="q"
                            aria-label={messages.search}
                            ref="searchText"
                            placeholder={messages.search_bar}
                            className="search-input text-color"
                            onChange={this.setSearch}
                            onFocus={this.onFocus}
                            onKeyUp={this.keyUp}
                            value={this.state.searchText}/>
                        <input
                            type="hidden"
                            name="limit"
                            value="all"/>
                    </div>
                    <div className={`search-btn search-btns ${hidden}`}>
                        <a
                            onClick={this.onSearch}
                            title={messages.search}>
                            <i className="eg-header-icon-search"></i>
                        </a>
                    </div>
                    {!this.context.isMobile ?
                        <div className={'close-btn search-btns'}>
                            <a onClick={this.props.hideSearch}>
                                <i className={'eg-header-icon-close'}></i>
                            </a>
                        </div>
                     : ''}
                </div>
            </div>
        );
    }
}

SearchExtension.propTypes = {
    active: React.PropTypes.bool,
    searchText: React.PropTypes.string,
    onSearch: React.PropTypes.func,
    hideSearch: React.PropTypes.func,
    searchMaxWidth: React.PropTypes.number
};

SearchExtension.contextTypes = {
    messages: React.PropTypes.object,
    isMobile: React.PropTypes.bool,
    isDesktop: React.PropTypes.bool,
    isTablet: React.PropTypes.bool
};



/** WEBPACK FOOTER **
 ** ./app/scripts/components/search/SearchExtension.js
 **/